module.exports = __webpack_public_path__ + "static/media/icon_under_construction.d1a47334.svg";